import * as Yup from 'yup'

import { CNPJValidator } from '../../../utils'

export default Yup.object().shape({
    cnpj: Yup.string().required('CNPJ é obrigatório!').test('CNPJ', 'Digite um CNPJ válido!', CNPJValidator.validate)
})